

<span style="filter: invert(27%) sepia(58%) saturate(2148%) hue-rotate(202deg) brightness(94%) contrast(96%);" >
    <slot />
</span>